import Swal from 'sweetalert2'
import Autenticacao from '@/services/Autenticacao'
import LoginForm from '@/components/Dashboard/Views/Forms/ValidationForms/LoginForm'

const landingURL = {
  path: `${process.env.LANDING_URL}/`
}

const controller = {
  name: 'LoginCtrl',
  components: {
    LoginForm
  },
  data () {
    return {
      landingURL
    }
  },
  methods: {
    onLoginSubmit (model, isValid) {
      if (isValid) {
        Autenticacao.entrar(model.email, model.password)
        .then((response) => {
          if (!response) {
            Autenticacao.sair()
            Swal(
              'Erro na autenticação!',
              'Email/Senha inválida ou email não verificado!',
              'error'
            )
          } else {
            this.$router.push({
              name: 'dashboard'
            })
          }
        })
        .catch(() => {
          Swal(
            'Erro na autenticação!',
            'Email/Senha inválida!',
            'error'
          )
        })
      }
    }
  },
  mounted () {
    document.getElementById('email').focus()
  }
}

export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Pages/LoginCtrl.js